import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const AppUninstall24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M2.8125 4.6875C2.8125 3.65197 3.65197 2.8125 4.6875 2.8125H9.1875C10.223 2.8125 11.0625 3.65197 11.0625 4.6875V9.1875C11.0625 10.223 10.223 11.0625 9.1875 11.0625H4.6875C3.65197 11.0625 2.8125 10.223 2.8125 9.1875V4.6875ZM4.3125 4.6875C4.3125 4.48039 4.48039 4.3125 4.6875 4.3125H9.1875C9.39461 4.3125 9.5625 4.48039 9.5625 4.6875V5.0625H4.3125V4.6875ZM9.5625 6.5625V9.1875C9.5625 9.39461 9.39461 9.5625 9.1875 9.5625H4.6875C4.48039 9.5625 4.3125 9.39461 4.3125 9.1875V6.5625H9.5625Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.9375 9.1875C12.9375 10.223 13.777 11.0625 14.8125 11.0625H19.3125C20.348 11.0625 21.1875 10.223 21.1875 9.1875V4.6875C21.1875 3.65197 20.348 2.8125 19.3125 2.8125H14.8125C13.777 2.8125 12.9375 3.65197 12.9375 4.6875V9.1875ZM14.8125 4.3125C14.6054 4.3125 14.4375 4.48039 14.4375 4.6875V5.0625H19.6875V4.6875C19.6875 4.48039 19.5196 4.3125 19.3125 4.3125H14.8125ZM19.6875 6.5625H14.4375V9.1875C14.4375 9.39461 14.6054 9.5625 14.8125 9.5625H19.3125C19.5196 9.5625 19.6875 9.39461 19.6875 9.1875V6.5625Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M2.8125 19.3125C2.8125 20.348 3.65197 21.1875 4.6875 21.1875H9.1875C10.223 21.1875 11.0625 20.348 11.0625 19.3125V14.8125C11.0625 13.777 10.223 12.9375 9.1875 12.9375H4.6875C3.65197 12.9375 2.8125 13.777 2.8125 14.8125V19.3125ZM4.6875 14.4375C4.48039 14.4375 4.3125 14.6054 4.3125 14.8125V15.1875H9.5625V14.8125C9.5625 14.6054 9.39461 14.4375 9.1875 14.4375H4.6875ZM9.5625 16.6875H4.3125V19.3125C4.3125 19.5196 4.48039 19.6875 4.6875 19.6875H9.1875C9.39461 19.6875 9.5625 19.5196 9.5625 19.3125V16.6875Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M19.2977 14.8672C19.5906 15.1601 19.5906 15.635 19.2977 15.9279L18.1405 17.0851L19.2977 18.2422C19.5906 18.5351 19.5906 19.01 19.2977 19.3029C19.0048 19.5958 18.5299 19.5958 18.237 19.3029L17.0798 18.1457L15.9227 19.3029C15.6298 19.5958 15.1549 19.5958 14.862 19.3029C14.5691 19.01 14.5691 18.5351 14.862 18.2422L16.0192 17.0851L14.862 15.9279C14.5691 15.635 14.5691 15.1601 14.862 14.8672C15.1549 14.5743 15.6298 14.5743 15.9227 14.8672L17.0798 16.0244L18.237 14.8672C18.5299 14.5743 19.0048 14.5743 19.2977 14.8672Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
